export default {
    name: "Breadcrumb",
    props: {
        page: String,
        path: String,
    },
};
